{
  "regions": "Regions",
  "serverTypes": "Server types",
  "images": "Images",
  "prices": "Prices",
  "region": "Region",
  "zone": "Zone",
  "city": "City",
  "type": "Type",
  "family": "Family",
  "architecture": "Architecture",
  "cpu": "vCPU",
  "memory": "RAM",
  "disk": "Disk",
  "traffic": "Traffic",
  "hourly": "Per hour",
  "monthly": "Per month",
  "allFamilies": "All families",
  "allArchitectures": "All architectures",
  "families": {
    "cost_optimized": "Cost-optimized",
    "regular_purpose": "Regular",
    "general_purpose": "Dedicated vCPU"
  },
  "cpuKind": {
    "shared": "shared",
    "dedicated": "dedicated"
  },
  "deprecated": "Being retired",
  "os": "OS",
  "version": "Version",
  "kind": "Kind",
  "rapidDeploy": "Fast deploy",
  "ipv4": "Public IPv4",
  "volume": "Volume, per GB",
  "snapshot": "Snapshot, per GB",
  "backups": "Backups",
  "backupsValue": "{{percent}}\u00a0% of the server price",
  "netPrices": "Prices without VAT, {{currency}}.",
  "intro": "What Hetzner offers this project and at what price. Use it to choose a server before creating one.",
  "serverTypesIntro": "Each type fixes vCPUs, memory and disk. Prices are per hour with a monthly cap; the region changes price and availability.",
  "regionsIntro": "Data centre locations. Private networks connect servers within one network zone.",
  "imagesIntro": "Operating systems and apps a new server can start from.",
  "pricesIntro": "Prices of everything billed on top of servers.",
  "zoneHint": "A network zone groups nearby locations; a private network spans one zone.",
  "onlyAvailable": "Only available here",
  "unavailableShort": "Not offered here",
  "trafficHint": "Outgoing traffic included per month; incoming traffic is free. Extra traffic is billed per TB.",
  "imageKinds": {
    "system": "System",
    "app": "App",
    "snapshot": "Snapshot",
    "backup": "Backup"
  },
  "ipv4Hint": "Each public IPv4 address is billed on its own, also while not assigned to a server. IPv6 is free.",
  "volumeHint": "Extra block storage you attach to a server, billed by size.",
  "snapshotHint": "A copy of a server disk you keep and can create servers from, billed by size.",
  "backupsHint": "Automatic daily copies, the last seven kept, priced as a share of the server.",
  "hourlyMonthly": "{{hourly}} per hour, up to {{monthly}} per month",
  "perMonth": "{{price}} per month"
}
